/* import __COLOCATED_TEMPLATE__ from './write-a-check.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { assertInstanceOf } from '@banking/ui/utils/assert';
import { inject as service } from '@ember/service';
import { get as getFromLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { HIDE_CHECK_EDUCATION_LOCAL_STORAGE_KEY } from '@banking/ui/workflows/balance/update';
let CreatePrintableCheckWrite = (_class = class CreatePrintableCheckWrite extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "logEvents", _descriptor, this);
    this.logEvents.track(this.args.writeCheckConfiguration?.logEvents?.viewLogEvent);
  }
  get isCheckEducationHidden() {
    return getFromLocalStorage(HIDE_CHECK_EDUCATION_LOCAL_STORAGE_KEY);
  }
  get currencySymbol() {
    return '$';
  }
  get memoPreviewText() {
    if (this.args.writeCheckConfiguration?.memoInput?.description?.label) {
      return this.args.writeCheckConfiguration.memoInput.description.label.split(' ')[1];
    }
    return '';
  }
  get imgSrc() {
    if (this.args.writeCheckConfiguration.preview?.rendered) {
      const {
        mimeType,
        imageBytes
      } = this.args.writeCheckConfiguration.preview.rendered;
      return `data:${mimeType};base64,${imageBytes}`;
    } else {
      return '';
    }
  }
  onIconClicked() {
    this.args.onShowEducation();
  }
  onAmountChange(money) {
    this.args.updateCreatePrintableCheckRequest('amount', money);
  }
  onInputChange(field, event) {
    const value = assertInstanceOf(event, CustomEvent).detail.value;
    this.args.updateCreatePrintableCheckRequest(field, value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onIconClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onIconClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAmountChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAmountChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _class);
export { CreatePrintableCheckWrite as default };